import { withInstall } from '../_util'

import Form from './Form.vue'
import StringInput from './StringInput/StringInput.vue'
import PasswordInput from './PasswordInput/PasswordInput.vue'
import Textarea from './Textarea/Textarea.vue'
import SingleSelect from './SingleSelect/SingleSelect.vue'
import MultiSelect from './MultiSelect/MultiSelect.vue'
import RadioGroup from './RadioGroup/RadioGroup.vue'
import CheckboxGroup from './CheckboxGroup/CheckboxGroup.vue'
import Checkbox from './Checkbox/Checkbox.vue'
import Switch from './Switch/Switch.vue'
import DateInput from './DateInput/DateInput.vue'
import FileInput from './FileInput/FileInput.vue'
import ButtonGroup from './ButtonGroup/ButtonGroup.vue'
import DiyItem from './DiyItem/DiyItem.vue'
import LovInput from './LovInput/LovInput.vue'
import NumberInput from './NumberInput/NumberInput.vue'
import TableSelect from './TableSelect/TableSelect.vue'

export default withInstall<
  typeof Form,
  {
    StringInput: typeof StringInput
    PasswordInput: typeof PasswordInput
    Textarea: typeof Textarea
    SingleSelect: typeof SingleSelect
    MultiSelect: typeof MultiSelect
    RadioGroup: typeof RadioGroup
    CheckboxGroup: typeof CheckboxGroup
    Checkbox: typeof Checkbox
    Switch: typeof Switch
    DateInput: typeof DateInput
    FileInput: typeof FileInput
    ButtonGroup: typeof ButtonGroup
    DiyItem: typeof DiyItem
    LovInput: typeof LovInput
    NumberInput: typeof NumberInput
    TableSelect: typeof TableSelect
  }
>(Form, {
  StringInput,
  PasswordInput,
  Textarea,
  SingleSelect,
  MultiSelect,
  RadioGroup,
  CheckboxGroup,
  Checkbox,
  Switch,
  DateInput,
  FileInput,
  ButtonGroup,
  DiyItem,
  LovInput,
  NumberInput,
  TableSelect,
})

export * from './Form'
export * from './StringInput'
export * from './PasswordInput'
export * from './Textarea'
export * from './SingleSelect'
export * from './MultiSelect'
export * from './RadioGroup'
export * from './CheckboxGroup'
export * from './Checkbox'
export * from './Switch'
export * from './DateInput'
export * from './FileInput'
export * from './ButtonGroup'
export * from './DiyItem'
export * from './LovInput'
export * from './NumberInput'
export * from './TableSelect'
